import styles from "./CountedProgress.module.css";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

type CountedProgressProps = {
  max: number;
  count: number;
  label: string;
  colorByCompletion?: boolean; // default: keep the existing green
  type?: "default" | "light";
};

function CountedProgress({
  max,
  count,
  label,
  colorByCompletion,
  type = "default",
}: CountedProgressProps) {
  const isComplete = max > 0 && count >= max;
  const barClassName = `${styles["bar"]} ${
    colorByCompletion
      ? isComplete
        ? styles["barComplete"]
        : styles["barInProgress"]
      : styles["barDefault"]
  }`;
  const barWrapperClassName = `${styles["barWrapper"]} ${
    type === "light"
      ? styles["barWrapper--light"]
      : styles["barWrapper--default"]
  }`;
  return (
    <div className={styles["root"]}>
      <div className={styles["top"]}>
        <FixaText textStyle="Heading.XS" tagName="h2">
          {label}
        </FixaText>
        <FixaText textStyle="Heading.XS">
          {count}/{max}
        </FixaText>
      </div>
      <div className={barWrapperClassName}>
        <div
          className={barClassName}
          style={{
            width:
              max === 0
                ? "100%"
                : `${Math.max(Math.min(count / max, 1), 0) * 100}%`,
          }}
        />
      </div>
    </div>
  );
}

export default CountedProgress;
